import { render } from "./CustomerProductProduct.vue?vue&type=template&id=4b12450e&ts=true"
import script from "./CustomerProductProduct.vue?vue&type=script&lang=ts"
export * from "./CustomerProductProduct.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__